<template>
	<transition name="slide-fade-up">
		<div :class="'snackbar ' + type" v-if="messages.length > 0">
			<div class="messages">
				<span class="message" v-for="(message, index) in messages">{{ message }}</span>
			</div>
			<span class="close" @click.prevent="messages = []">&times;</span>
		</div>
	</transition>
</template>

<script>
	export default {
		props: ['type', 'value'],
		data() {
			return {
				messages: this.value
			};
		},
		watch: {
			value() {
				this.messages = this.value;
			},
			messages() {
				this.$emit('input', this.messages);
			}
		}
	}
</script>